<template>
    <form @submit.prevent="send" class="popup__form form-sms">
        <div class="h3 form-sms__title">{{ trans('auth.login_by_telephone_number') }}</div>
        <div class="form-sms__description">{{ trans('auth.enter_your_mobile_number_and_you_will_receive_code') }}</div>
        <div class="form-sms__fieldset">
            <div class="form-sms__line">
                <phone-number-input 
                    style="padding-bottom: 8px;"
                    v-model="phone"
                    :user="user" :label="trans('general.phone')"
                    :full_check="false"
                ></phone-number-input>
                <div class="form-sms__input-label label-field only-text" :class="phoneError.status">
                    <!-- <span>{{ trans('general.phone') }}</span>
                    <div class="mask-phone">
                        <input
                            maxlength="12"
                            v-model="phone"
                            data-required
                            type="tel"
                            name="tel"
                            :placeholder="trans('general.phone') + ' 380991112233'"
                            class="input form-sms__input"
                        />
                    </div> -->
                    <input-notification :data="phoneError" />
                </div>
                <div v-if="time > 0" class="form-sms__description">
                    {{ trans('auth.new_code_can_be_requested_via') }} {{ time }} {{ trans('auth.seconds') }}
                </div>
            </div>
        </div>
        <button type="submit" class="form-sms__button button btn">
            {{ trans('auth.get_code') }}
        </button>
    </form>
</template>

<script>
import inputNotification from "./../inc/InputNotification";
import phoneNumberInput from "./../inc/phoneNumberInput";

export default {
    components: {
        "input-notification": inputNotification,
        "phone-number-input": phoneNumberInput
    },
    props: {
        time: {
            required: true
        },
        phoneError: {
            required: true
        }
    },
    data() {
        return {
            phone: null
        }
    },

    // watch: {
    //     phone: {
    //         handler(data){
    //             if(!/^[0-9]+$/.test(data)) {
    //                 let updated = data.replace(/\D/, "");
    //                 this.phone = updated;
    //             }
    //         }
    //     }
    // },
    methods: {
        send() {
            this.$emit("send", this.phone);
        }
    }
}
</script>